module.exports = __webpack_public_path__ + "static/media/reports.1b02cf35.svg";